const STAGE = process.env.REACT_APP_STAGE

export let AllRolesList = {}

if(STAGE !== 'removeFS'){
    AllRolesList = {
        "Main Hub" : [
            "Classes" , "Sections" , "Subjects", "Exams","Class Association"
        ],
        "Fees" :[
            "Fee Heads","Fee Structures" , "Fee Terms"
        ],
        "Students-Activity" : [
            "Directory","Attendance","Academic Reports",
            "Promote Students","Transfers"
        ],
        "Students-Fee":["Invoices",'Collect Fee:Receipt', 'Collect Fee:RTE', 
            'Collect Fee:Scholarship','Collect Fee:Discount',
            'Collect Fee:Write-off','Fee Collection Report'],
        "Notice Board" : [
            "Classroom", "Broadcasts"
        ],
        "Employees" : [
            "Directory ",
            "Attendance",
            "Payroll"
        ],
        "Inventory" : [
            "Inventory", "Purchase Order","GRN Entry","Inventory Stock Report",
            "Inventory Issue Report"
        ],
        "Accounting" : [
            "Ledgers/Groups","Vouchers Entry","Payables"
        ],
        
        "Financial Statements" : [
            "Balance Sheet", "Profit and Loss Sheet", "Trial Balance Sheet",
            "Receipts and Payments"
        ],

        "Holiday Management" :[],
        
        "Financial Years": ["Financial Years"],
    
        "Institution" : [
            "Institution Users"
        ],
        
    }
} else {
    AllRolesList = {
        "Main Hub" : [
            "Classes" , "Sections" , "Subjects","Exams","Class Association"
        ],
        "Fees" :[
            "Fee Heads","Fee Structures" , "Fee Terms"
        ],
        "Students-Activity" : [
            "Directory","Attendance",
            "Academic Reports","Promote Students","Transfers",
        ],
        "Students-Fee":["Invoices",'Collect Fee','Fee Collection Report'],
        "Notice Board" : [
            "Classroom", "Broadcasts"
        ],
        "Employees" : [
            "Directory ",
            "Attendance",
            "Payroll"
        ],
        "Inventory" : [
            "Inventory", "Purchase Order","GRN Entry","Inventory Stock Report",
            "Inventory Issue Report"
        ],
        "Accounting" : [
            "Ledgers/Groups","Vouchers Entry","Payables"
        ],
        "Branch" : [
            "Branches"
        ],
        "Holidays" : [
            "Holiday Management"
        ],
        "Financial Years":["Financial Years"],
        "Institution" : [
            "Institution Users"
        ],
    }
}
